export default ({
    firebase: {
        serverKey: 'xxxxxxxxxxxxxxxxxxxxxxxx'
    },
    testerUrl: 'https://jsonplaceholder.typicode.com/users',
    menu: {
        menu1: 'https://httpbin.org/get',
        menu2: 'https://httpbin.org/get'
    }
});
